export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14623.45d51e21.jpg";